import { render, staticRenderFns } from "./OlympicsStartModal.vue?vue&type=template&id=8d31c882&"
import script from "./OlympicsStartModal.vue?vue&type=script&lang=js&"
export * from "./OlympicsStartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports